import { render, staticRenderFns } from "./chateau-petrus.vue?vue&type=template&id=11e7eebc&scoped=true"
import script from "./chateau-petrus.vue?vue&type=script&lang=js"
export * from "./chateau-petrus.vue?vue&type=script&lang=js"
import style0 from "./chateau-petrus.vue?vue&type=style&index=0&id=11e7eebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e7eebc",
  null
  
)

export default component.exports